<template>
	<div class="w-100" style="padding-top: 1rem">
		<div class="w-100  d-flex align-items-center justify-content-between">
			<label
				class="mb-2"
				style="color:#676767"
				v-if="label!=''"
			>
				{{label}}
				<b v-if="(set_error()!='' && error_text!='')" class="is-invalid">
					({{error_text}})
				</b>
			</label>
			<button v-if="leading" type="button" class="btn btn-secondary" style="background: none;border: none;" data-toggle="tooltip" data-html="true" :title="leading">
				<svg style="width: 18px;height: 18px;" fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px" viewBox="0 0 416.979 416.979" xml:space="preserve"> <g> <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M208.554,334.794 c-11.028,0-19.968-8.939-19.968-19.968s8.939-19.969,19.968-19.969c11.028,0,19.968,8.939,19.968,19.969 C228.521,325.854,219.582,334.794,208.554,334.794z M241.018,214.566c-11.406,6.668-12.381,14.871-12.43,38.508 c-0.003,1.563-0.008,3.14-0.017,4.726c-0.071,11.172-9.147,20.18-20.304,20.18c-0.044,0-0.088,0-0.131,0 c-11.215-0.071-20.248-9.22-20.178-20.436c0.01-1.528,0.013-3.047,0.016-4.552c0.05-24.293,0.111-54.524,32.547-73.484 c26.026-15.214,29.306-25.208,26.254-38.322c-3.586-15.404-17.653-19.396-28.63-18.141c-3.686,0.423-22.069,3.456-22.069,21.642 c0,11.213-9.092,20.306-20.307,20.306c-11.215,0-20.306-9.093-20.306-20.306c0-32.574,23.87-58.065,58.048-61.989 c35.2-4.038,65.125,16.226,72.816,49.282C297.824,181.361,256.555,205.485,241.018,214.566z"/> </g> </svg>
			</button>
		</div>
		
		<input
			:id="set_id()"
			:type="type"
			class="form-Control p-3"
			:class="set_error() + textClass"
			style="background-color: #f5fafd; border: 1px solid #e5ebeb; color: #219580; border-radius:10px; background-size: 20px; background-repeat: no-repeat; background-position: 15 center;"
			:style="set_img_input() + input_style"
			:placeholder="(placeholder=='') ? label : placeholder"
			v-model="val"
			@input="inputTxt($event)"
			@click='enterFunc'
			ref='focusMe'
			@keyup.enter='enterFunc'
			@blur="set_error(); blurinputTxt($event);"
			autocomplete="new-password"
			:disabled="disabled"
		/>
	</div>
</template>
<script>
	export default {
		name: 'textInput',
		data(){
			return {
				imgurl: window.imgurl,
				baseurl: window.baseurl,
		
				p_num : ["۰", '۱','۲','۳','۴','۵','۶','۷','۸','۹'],
				e_num : ["0", '1','2','3','4','5','6','7','8','9'],
			}
		},
		components: {

		},
		props: {
			input_style:{
				default: "",
			},
			type: {
				type: String,
				default: "text",
			},
			error: {
				type: Boolean,
				default: false,
			},
			blur_error: {
				type: Boolean,
				default: false,
			},
			error_text: {
				type: String,
				default: "",
			},
			autofocus: {
				type: String,
				default: "false",
			},
			label: {
				type: String,
				default: "label",
			},
			leading: {
				type: String,
				default: "",
			},
			val: {
				type: String,
				default: "",
			},
			placeholder: {
				type: String,
				default: "",
			},
			img: {
				default: "",
			},
			disabled: {
				default: false,
			},
			textClass: {
				type: String,
				default: "",
			},
			id_input: {
				type: String,
				default: "",
			},
			valid:{
				default: -1
				//-1 خالی
				// 1 تایید
				// 0 رد
			},
			empty:{
				default: false,
			},
		},
		mounted(){
			if(this.autofocus != "false"){
				this.$nextTick(() => this.$refs.focusMe.focus());
			}
			if(this.error){
				this.set_error();
			}
			$(function () {
				$('[data-toggle="tooltip"]').tooltip()
			})

		},
		methods:{
			set_id(){
				var random = parseInt(Math.random()*1000000);
				var id_input = (this.id_input=="") ? ("input_" + random) : this.id_input;
				return( id_input );
			},
			//__________________________________________________________________
			set_img_input(){
				var value = "";
				if(this.valid==-1 && this.img!=""){
					value = 'background-image: url('+this.img+');'
				}else if (this.valid==1) {
					value = 'background-image: url('+require('../../assets/img/input_tick.svg')+');';
				}else if (this.valid==0) {
					value = 'background-image: url('+require('../../assets/img/input_x.svg')+');';
				}
				return value;
			},
			//__________________________________________________________________
			set_error(){
				return	(this.blur_error && this.error) ? " is-invalid " : "" ;
			},
			//__________________________________________________________________
			enterFunc(event){
				var val = event.target.value.trim();
				for (let index = 0; index < this.p_num.length; index++) {
					val = val.replaceAll(this.p_num[index], this.e_num[index]);
				}
				if(event.target.value != '' || this.empty){
					this.$emit('enter', val);
				}
			},
			//__________________________________________________________________
			inputTxt(event){
				var val = event.target.value.trim();
				for (let index = 0; index < this.p_num.length; index++) {
					val = val.replaceAll(this.p_num[index], this.e_num[index]);
				}
				this.$emit('inputTxtFunc', val);
			},
			//__________________________________________________________________
			blurinputTxt(event){
				var val = event.target.value.trim();
				for (let index = 0; index < this.p_num.length; index++) {
					val = val.replaceAll(this.p_num[index], this.e_num[index]);
				}
				this.$emit('blurinputTxtFunc', val);
			},
		}
	}
</script>

<style scope>
	.is-invalid{
		border-color: #fa6a6e !important;
		color: #fa6a6e !important;
	}
	input::placeholder{
		text-align: right !important;
	}
</style>
